import ProgramCard from '../components/ProgramCard'
import CTASection from '../components/CTASection'
import SectionHeader from '../components/SectionHeader'
import { PROGRAMS } from '../content/siteContent'

export default function ProgramsPage() {
  const available  = PROGRAMS.items.filter((p) => p.available)
  const unavailable = PROGRAMS.items.filter((p) => !p.available)

  return (
    <main>
      {/* Page hero */}
      <section className="bg-gradient-to-br from-brand-navy to-brand-blue pt-32 pb-16 relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '32px 32px' }} aria-hidden="true" />
        <div className="section-container relative z-10 text-center">
          <p className="text-brand-amber text-xs font-round font-bold tracking-[0.15em] uppercase mb-3">Programs &amp; Care</p>
          <h1 className="text-4xl md:text-5xl font-display font-bold text-white mb-4">{PROGRAMS.headline}</h1>
          <p className="text-slate-200 text-lg max-w-xl mx-auto">{PROGRAMS.subheadline}</p>
        </div>
        <div className="absolute bottom-0 left-0 right-0" aria-hidden="true">
          <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none">
            <path d="M0 60V30C240 0 480 50 720 30C960 10 1200 50 1440 30V60H0Z" fill="white" />
          </svg>
        </div>
      </section>

      {/* Enrollment notice */}
      <section className="bg-white py-8">
        <div className="section-container">
          <div className="bg-brand-sky/10 border border-brand-sky/30 rounded-xl3 px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center gap-3 justify-between text-center sm:text-left">
            <p className="text-brand-navy font-semibold text-sm md:text-base">
              🎉 {PROGRAMS.enrollmentNote}
            </p>
            <a href="/#contact" className="btn-primary shrink-0 text-sm">
              Schedule a Tour
            </a>
          </div>
        </div>
      </section>

      {/* Active programs */}
      <section className="section-pad bg-white">
        <div className="section-container">
          <SectionHeader eyebrow="Current Openings" headline="Our Active Programs" subheadline="Each program is designed around your child's developmental stage, offering loving care and intentional learning every day." />
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {available.map((p) => (
              <ProgramCard key={p.id} {...p} />
            ))}
          </div>
        </div>
      </section>

      {/* What a day looks like */}
      <section className="section-pad bg-brand-ivory">
        <div className="section-container">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <SectionHeader eyebrow="Daily Life" headline="What a Day at Grace Pointe Looks Like" centered={false} />
              <div className="space-y-4">
                {[
                  { time: '7:00 AM', label: 'Doors Open',            body: 'Warm welcome and free play as families arrive.' },
                  { time: '8:30 AM', label: 'Morning Circle',        body: 'Songs, prayer, calendar time, and group activities.' },
                  { time: '9:30 AM', label: 'Learning Centers',      body: 'Structured play across literacy, math, art, and sensory stations.' },
                  { time: '11:30 AM', label: 'Lunch & Rest',         body: 'Nutritious lunch and quiet rest time.' },
                  { time: '1:30 PM', label: 'Afternoon Activities',  body: 'Outdoor play, music, stories, and creative exploration.' },
                  { time: '5:30 PM', label: 'Close',                 body: 'A peaceful end to a full, joyful day.' },
                ].map((item) => (
                  <div key={item.time} className="flex gap-4 items-start">
                    <div className="text-xs font-bold text-brand-blue bg-brand-sky/15 rounded-lg px-2 py-1 shrink-0 w-20 text-center mt-0.5">
                      {item.time}
                    </div>
                    <div>
                      <p className="font-semibold text-brand-navy text-sm">{item.label}</p>
                      <p className="text-slate-500 text-sm">{item.body}</p>
                    </div>
                  </div>
                ))}
              </div>
              {/* TODO: Confirm actual daily schedule with center director */}
              <p className="mt-4 text-xs text-slate-400">* Sample schedule — varies by age group. Contact us for specifics.</p>
            </div>
            <div className="grid grid-cols-2 gap-3 sm:gap-4">
              <img src="/images/IMG_7480.jpg" alt="Children in classroom" className="rounded-xl3 shadow-card aspect-square object-cover" loading="lazy" />
              <img src="/images/IMG_7558.jpg" alt="Learning activities" className="rounded-xl3 shadow-card aspect-square object-cover mt-6" loading="lazy" />
              <img src="/images/IMG_7629.jpg" alt="Outdoor play" className="rounded-xl3 shadow-card aspect-square object-cover" loading="lazy" />
              <img src="/images/IMG_7707.jpg" alt="Art and creative time" className="rounded-xl3 shadow-card aspect-square object-cover mt-6" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {/* Coming soon programs */}
      {unavailable.length > 0 && (
        <section className="section-pad bg-white">
          <div className="section-container">
            <SectionHeader eyebrow="Coming Soon" headline="Expanding Our Programs" subheadline="We're always exploring ways to serve more families. Stay tuned for upcoming offerings." />
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {unavailable.map((p) => (
                <ProgramCard key={p.id} {...p} />
              ))}
            </div>
          </div>
        </section>
      )}

      <CTASection />
    </main>
  )
}
